export default __webpack_public_path__ + "static/Row 2.3_Pei Tong-a662f4941a82722efda117dc8d2e3b33.jpg";